import * as React from 'react';
import { Skeleton } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';

const LoadingData = ()=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(Skeleton, {
        height: 60,
        width: "100%",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": getLabel('common.loadingText')
    }, /*#__PURE__*/ React.createElement("rect", {
        width: "40%",
        height: "15px",
        rx: "5",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: "25%",
        height: "15px",
        rx: "5",
        fill: "currentColor",
        y: "30"
    }));
};

export { LoadingData };
//# sourceMappingURL=LoadingData.js.map
